export const pipelineTypes = {
    DEFAULT: 'default',
    HISTORICAL: 'historical',
    QUARTERLY: 'quarterly',
};

const commonColumns = [{
    name: '# of Properties',
    key: 'properties',
    class: 'Pipeline_column_numeric',
}, {
    name: 'Total Price',
    key: 'totalPrice',
    class: 'Pipeline_column_numeric',
    format: '$',
}, {
    name: 'Total Gross Fee',
    key: 'totalGrossFee',
    class: 'Pipeline_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'Split w/ Outside Agent',
    key: 'split',
    class: 'Pipeline_column_numeric',
    format: '$',
    withCents: true,
}, {
    name: 'STRIVE Fee',
    key: 'striveGrossFee',
    class: 'Pipeline_column_numeric',
    format: '$',
    withCents: true,
}];

export const defaultColumns = [{
    name: 'Status',
    key: 'status',
}].concat(commonColumns);

export const historicalColumns = [{
    name: 'Category',
    key: 'category',
}, {
    name: 'Type',
    key: 'type',
}].concat(commonColumns);

export const quarterlyColumns = [{
    name: 'Quarter',
    key: 'quarter',
}].concat(historicalColumns);